import { FormattedMessage } from 'react-intl';

export const dropdownSortOrderMessages = {
  'dropdownSortOrder.label': (
    <FormattedMessage
      id="dropdownSortOrder.label"
      defaultMessage="Sorted by:"
    />
  ),
  'dropdownSortOrder.ascending': (
    <FormattedMessage id="dropdownSortOrder.ascending" defaultMessage="A-Z" />
  ),
  'dropdownSortOrder.descending': (
    <FormattedMessage id="dropdownSortOrder.descending" defaultMessage="Z-A" />
  ),
};
